import React from "react";
import { Controller } from "react-hook-form";

const RhfController = ({
  control,
  element,
  required,
  errors,
  name,
  ispassword,
}) => {
  return (
    <React.Fragment>
      <Controller
        rules={{ required: required ?? false }}
        name={name}
        control={control}
        render={({ field: { onChange } }) =>
          React.cloneElement(element, {
            onChange,
            errors,
            name,
            ispassword,
          })
        }
      />
    </React.Fragment>
  );
};

export default RhfController;
